import { useEffect, useState } from 'react';
import { AiService } from '../../services/ai';
import { useTranslation } from '../../i18n';

/** R7.5 "Customers say…" -- a stored AI summary, labelled as such. Renders
 * nothing when the product has none (fewer than 5 reviews / AI off). */
export default function ReviewSummaryCard({ productId }) {
  const { t } = useTranslation();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let alive = true;
    setSummary(null);
    if (productId) AiService.reviewSummary(productId).then((res) => { if (alive && res.success) setSummary(res.summary); });
    return () => { alive = false; };
  }, [productId]);

  if (!summary) return null;
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="review-summary">
      <div className="flex flex-wrap items-center gap-2">
        <h3 className="text-sm font-semibold text-slate-900">{t('ai.reviewSummary.title')}</h3>
        <span className="rounded-full bg-indigo-100 px-2 py-0.5 text-[11px] font-semibold text-indigo-800">
          {t('ai.reviewSummary.badge')}
        </span>
      </div>
      {summary.summary && <p className="mt-2 text-sm text-slate-700">{summary.summary}</p>}
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        {summary.pros?.length > 0 && (
          <div>
            <p className="text-xs font-semibold text-emerald-700">{t('ai.reviewSummary.pros')}</p>
            <ul className="mt-1 list-disc ps-5 text-sm text-slate-700">{summary.pros.map((p) => <li key={p}>{p}</li>)}</ul>
          </div>
        )}
        {summary.cons?.length > 0 && (
          <div>
            <p className="text-xs font-semibold text-amber-700">{t('ai.reviewSummary.cons')}</p>
            <ul className="mt-1 list-disc ps-5 text-sm text-slate-700">{summary.cons.map((c) => <li key={c}>{c}</li>)}</ul>
          </div>
        )}
      </div>
      <p className="mt-3 text-xs text-slate-500">{t('ai.reviewSummary.footer', { count: summary.review_count })}</p>
    </section>
  );
}
